export default __webpack_public_path__ + "static/media/插件中心.c452dd5c.gif";